module.exports = __webpack_public_path__ + "static/media/site-mock-01.851eeff1.jpg";